import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getNombreProductos`, method: 'GET', body: null, token: token})
}